import { LoginForm } from 'react-admin';
import { Box, Typography, Card } from '@mui/material';

const CustomLoginForm = () => (
    <LoginForm />
);

export const LoginPage = () => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
        }}
    >
        <Card sx={{ minWidth: 300, padding: 4 }}>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
                <img 
                    src="https://looton.ru/assets/looton-logo-CD_loYgG.svg" 
                    alt="Looton Logo" 
                    style={{ width: '150px', marginBottom: '16px' }}
                />
                <Typography variant="h5" component="h1" gutterBottom>
                    Rocket System
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Войдите, чтобы продолжить
                </Typography>
            </Box>
            <CustomLoginForm />
        </Card>
    </Box>
); 